export default __webpack_public_path__ + "static/media/definix-black-mini-logo.0aa696a1.png";